<template>
  <v-app>

    <v-overlay :value="$store.state.user.overlay" v-if="$store.state.user.overlay">
      <v-progress-circular indeterminate size="64" v-if="$store.state.user.overlay">
        Procesando
      </v-progress-circular>
    </v-overlay>
    
    <v-navigation-drawer v-if="$store.state.user.authenticated" persistent :mini-variant="miniVariant" :clipped="clipped" v-model="drawer" enable-resize-watcher fixed app>
      <p class="text-center" style="margin-bottom: 0;">
        <router-link :to="{ name: 'home'}" target="_self">
          <img src="@/assets/logo_infilesign.jpg" alt="Infile Sign" class="">
        </router-link>
        <v-btn  
          :rounded="!miniVariant ? true : false"
          :large="!miniVariant ? true : false"
          :fab="miniVariant ? true : false" 
          :small="miniVariant ? true : false"
          @click="changeitem({ 'link': 'documento', 'params': {'opt': 'create'}})"
          color="#4DB0F6" dark>
          <v-icon color="lighten-1">mdi-plus</v-icon>
          <span v-if="!miniVariant">Cargar Documento</span>
        </v-btn>
      </p>

      <v-treeview
        dense
        :open="open"
        :items="$store.state.user.main_menu"
        open-on-click
      >
      <template v-slot:label="{item, open, selected}">
        <v-list dense style="padding: 0">
          <v-list-item 
            class="pl-0"
            :key="item.id" 
            :target="'_self'"
            :class="item.link === $route.name ? 'v-list-item--active' : ''"
            @click="changeitem(item)"
            >
            <v-icon left color="rgba(0, 0, 0, 0.77)">
              {{item.icon}}
            </v-icon>
            <v-list-item-title color="primary"><span style="color: rgba(0, 0, 0, 0.77);">{{ item.nombre }}</span></v-list-item-title>
          </v-list-item>
        </v-list>
      </template>
      </v-treeview>

      <!-- carpetas personales -->
      <v-list-group prepend-icon="settings" value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Carpetas</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-treeview
          dense
          :open="open"
          :items="$store.state.user.menu_personal"
          open-on-click
        >
        <template v-slot:label="{item, open, selected}">
          <v-list dense style="padding: 0">
            <v-list-item 
              class="pl-0"
              :key="item.nombre"
              :target="'_self'"
              @click="changeitem(item)"
              :class="item.id === $route.params.id ? 'v-list-item--active' : ''"
              >
              <v-icon 
                v-if="item.carpeta_padre_id == '0' && item.children.length == 0" 
                left color="rgba(0, 0, 0, 0.77)">
                  mdi-folder-move
              </v-icon>
              <v-icon 
                v-if="
                  (item.carpeta_padre_id == '0' && item.children.length > 0) ||
                  (item.carpeta_padre_id != '0' && item.children.length > 0) ||
                  (item.carpeta_padre_id != '0' && item.children.length == 0)
                " 
                left color="rgba(0, 0, 0, 0.77)">
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
              <v-list-item-title color="primary"><span style="color: rgba(0, 0, 0, 0.77);">{{ item.nombre }}</span></v-list-item-title>
            </v-list-item>
          </v-list>
        </template>
        </v-treeview>
      </v-list-group>
     
      <v-list-group v-if="$store.state.user.ver_expedientes" prepend-icon="settings" value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Expedientes</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-treeview
          dense
          :open="open"
          :items="$store.state.user.menu_expediente"
          open-on-click
        >
        <template v-slot:label="{item, open, selected}">
          <v-list dense style="padding: 0">
            <v-list-item 
              class="pl-0"
              :key="item.nombre" 
              :target="'_self'"
              @click="changeitem(item)"
              :class="item.id === $route.params.id ? 'v-list-item--active' : ''">
              <v-icon 
                v-if="item.carpeta_padre_id == '0' && item.children.length == 0" 
                left color="rgba(0, 0, 0, 0.77)">
                mdi-folder-network-outline
              </v-icon>
              <v-list-item-title color="primary"><span style="color: rgba(0, 0, 0, 0.77);">{{ item.nombre }}</span></v-list-item-title>
            </v-list-item>
          </v-list>
        </template>
        </v-treeview>
      </v-list-group>
     
    </v-navigation-drawer>

    <v-app-bar v-if="$store.state.user.authenticated" app :clipped-left="clipped" color="info" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" ></v-app-bar-nav-icon>
      <v-btn class="d-none d-lg-flex" icon @click.stop="miniVariant = !miniVariant">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn>
      <v-btn class="d-none d-lg-flex" icon @click.stop="clipped = !clipped">
        <v-icon>web</v-icon>
      </v-btn>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
        {{$store.state.user.email}}
      <v-menu bottom left v-if="$store.state.user.authenticated">
        <template v-slot:activator="{ on }">
          <v-btn dark icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <!-- ver expedientes -->
          <v-list-item 
            v-if="$store.state.user.crear_expedientes"
            v-for="(item_, i) in mides" 
            :key="item_.nombre"
            @click="changeitem(item_)" 
            :target="'_self'">
            <v-list-item-action>
            <v-icon v-html="item_.icon"></v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="item_.nombre"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="$store.state.user.authenticated" 
            v-for="(item, i) in itemsLogin" 
            :key="item.title" 
            :to="{name: item.link}">
            <v-list-item-action>
            <v-icon v-html="item.icon"></v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <v-snackbar
        v-model="$store.state.user.show_error"
        :color="$store.state.user.type_error"
        :multi-line="true"
        :timeout="8000"
        :bottom="true"
        :right="true"
      >
        {{$store.state.user.text_error}}
        <v-btn dark text @click="$store.state.user.show_error = false" >
          Cerrar
        </v-btn>
      </v-snackbar>
      <!-- <router-view/> -->
      <router-view :key="$route.fullPath"></router-view>
    </v-content>

    <v-footer app>
      <span>&nbsp;Infile&nbsp;&copy;&nbsp;2020</span>
    </v-footer>

  </v-app>
</template>

<script>
    export default {         

    data: function() {
      return {
        clipped :true,
        drawer : true,
        miniVariant : false,
        right : true,
        title : 'Infile-Sign',
        itemsLogin : [
          { title: 'Rubricas', icon: 'edit', link: 'usuario_rubrica_index' },
          { title: 'Carpetas', icon: 'mdi-file-settings-outline', link: 'expediente_crear'},
          { title: 'Salir', icon: 'logout', link: 'logout' },
        ],
        mides : [
          { nombre: 'Flujos', icon: 'mdi-ruler-square-compass', link: 'expediente_flujo' },
        ],
        tree: [],
        open: [],
      };
    },
    computed: {
    },
    mounted() {
      
    },
    methods: {
      makeid(l) {
         var result           = '';
         var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
         var charactersLength = characters.length;
         for ( var i = 0; i < l; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
         }
         return result;
      },
      changeitem(e){
        //console.log(e);
        this.$store.state.user.expediente = [];
        if(e.link == "documento"){
          this.$router.push({'name': e.link, params: {'opt': 'create'}, query:{'u': this.makeid(4) }});
        } else if (e.link == "expedientes" || e.link == "carpeta_personal" || e.link == "carpeta_lote") {
          this.$store.state.user.expediente = e;
          this.$router.push({'name': e.link, params: {'id': e.id}, query:{'u': this.makeid(4) }});
        } else {
          this.$router.push({'name': e.link, query:{'u': this.makeid(4) }});
        }
      }
    },
  };
</script>

